export default [
    // {
    //     path: '/loginOld',
    //     name: 'loginOld',
    //     component: () => import('@/views/old/accnt/loginOld.vue')
    // },
    // {
    //     path: '/signUp',
    //     name: 'signUp',
    //     component: () => import('@/views/accnt/signUp.vue')
    // },
    // {
    //     path: '/pwSet01',
    //     name: 'pwSet01',
    //     component: () => import('@/views/accnt/pwSet01.vue')
    // },
    // {
    //     path: '/pwSet02',
    //     name: 'pwSet02',
    //     component: () => import('@/views/accnt/pwSet02.vue')
    // },
    // {
    //     path: '/memRetr',
    //     name: 'memRetr',
    //     component: () => import('@/views/accnt/memRetr.vue')
    // },
]